import { Button, Form } from "antd";
import { useTranslation } from "react-i18next";

import { useGetSettings, useUpdateSettings } from "@/entities/settings";
import SelectLangField from "@/modules/language/language-select-lang-field";

const { useForm } = Form;

const TabGeneral = () => {
  const { t } = useTranslation();
  const [form] = useForm();

  const { settings, isLoading } = useGetSettings();
  const { mutate, isPending } = useUpdateSettings();

  const onSave = ({ language }) => {
    // Just update settings locale. i18n locale will be updated by the
    // <LanguageHandler> loaded in <App> everytime settings locale is updated
    mutate({ locale: language });
  };

  if (isLoading) return null;

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onSave}
      initialValues={{
        language: settings?.locale,
      }}
    >
      <SelectLangField initialValue={settings?.locale} />
      <Button type="primary" htmlType="submit" loading={isPending}>
        {t("global:save")}
      </Button>
    </Form>
  );
};

export default TabGeneral;
